import * as Dropzone from 'dropzone';

import {NgZone, SimpleChanges, KeyValueDiffers} from '@angular/core';
import {Component, Optional, OnInit, DoCheck, OnDestroy, OnChanges} from '@angular/core';
import {Input, Output, HostBinding, EventEmitter, ElementRef, ViewEncapsulation} from '@angular/core';

import {DropzoneEvents, DropzoneConfig, DropzoneConfigInterface} from './dropzone.interfaces';
import {DropzoneThumbnail} from "./dropzone.thumbnail";


export class DropzoneComponent implements OnInit, DoCheck, OnDestroy, OnChanges {
    public dropzone: any;

    private configDiff: any;

     disabled: boolean = false;
     config: DropzoneConfigInterface;
     runInsideAngular: boolean = false;
     message: string = 'Click or drag files to upload';
     placeholder: string = '';
     thumbnails: DropzoneThumbnail[] = [];

      useDropzoneClass: boolean = true;
      useDzWrapperClass: boolean = true;

     dz_drop = new EventEmitter<any>();
     dz_dragstart = new EventEmitter<any>();
     dz_dragend = new EventEmitter<any>();
     dz_dragenter = new EventEmitter<any>();
     dz_dragover = new EventEmitter<any>();
     dz_dragleave = new EventEmitter<any>();
     dz_addedfile = new EventEmitter<any>();
     dz_addedfiles = new EventEmitter<any>();
     dz_removedfile = new EventEmitter<any>();
     dz_thumbnail = new EventEmitter<any>();
     dz_error = new EventEmitter<any>();
     dz_errormultiple = new EventEmitter<any>();
     dz_processing = new EventEmitter<any>();
     dz_uploadprogress = new EventEmitter<any>();
     dz_sending = new EventEmitter<any>();
     dz_success = new EventEmitter<any>();
     dz_complete = new EventEmitter<any>();
     dz_canceled = new EventEmitter<any>();
     dz_maxfilesreached = new EventEmitter<any>();
     dz_maxfilesexceeded = new EventEmitter<any>();
     dz_processingmultiple = new EventEmitter<any>();
     dz_sendingmultiple = new EventEmitter<any>();
     dz_successmultiple = new EventEmitter<any>();
     dz_completemultiple = new EventEmitter<any>();
     dz_canceledmultiple = new EventEmitter<any>();
     dz_totaluploadprogress = new EventEmitter<any>();
     dz_reset = new EventEmitter<any>();
     dz_queuecomplete = new EventEmitter<any>();

    constructor(private zone: NgZone, private elementRef: ElementRef, private differs: KeyValueDiffers,
                 private defaults: DropzoneConfig) {
        Dropzone.autoDiscover = false;
    }

    ngOnInit() {
        let element = this.elementRef.nativeElement;

        let options = new DropzoneConfig(this.defaults);

        options.assign(this.config); // Custom config

        if (this.runInsideAngular) {
            this.dropzone = new Dropzone(element, options);
        } else {
            this.zone.runOutsideAngular(() => {
                this.dropzone = new Dropzone(element, options);
            });
        }

        if (this.disabled) {
            if (this.runInsideAngular) {
                this.dropzone.disable();
            } else {
                this.zone.runOutsideAngular(() => {
                    this.dropzone.disable();
                });
            }
        }

        this.dropzone.on('error', (err) => {
            if (options.errorReset != null) {
                setTimeout(() => this.reset(), options.errorReset);
            }
        });

        this.dropzone.on('success', (res) => {
            if (options.autoReset != null) {
                setTimeout(() => this.reset(), options.autoReset);
            }
        });

        this.dropzone.on('canceled', (res) => {
            if (options.cancelReset != null) {
                setTimeout(() => this.reset(), options.cancelReset);
            }
        });

        // Add native dropzone event handling
        DropzoneEvents.forEach((eventName) => {
            let self = this;

            this.dropzone.on(eventName, function (event) {
                let args = Array.prototype.slice.call(arguments);

                if (args.length === 1) {
                    args = args[0];
                }

                self[`dz_${eventName}`].emit(args);
            });
        });


        if (!this.configDiff) {
            this.configDiff = this.differs.find(this.config || {}).create(null);
        } else {
            this.thumbnails.forEach((thumbnail) => {
                this.dropzone.emit('addedfile', thumbnail);
                this.dropzone.emit('thumbnail', thumbnail, thumbnail.url);
                this.dropzone.createThumbnailFromUrl(thumbnail, thumbnail.url, null, 'anonymous');
                this.dropzone.emit('complete', thumbnail);
                this.dropzone.options.maxFiles = this.dropzone.options.maxFiles - 1;
            });
        }
    }

    ngDoCheck() {
        let changes = this.configDiff.diff(this.config || {});

        if (changes && this.dropzone) {
            this.ngOnDestroy();

            this.ngOnInit();
        }
    }

    ngOnDestroy() {
        if (this.runInsideAngular) {
            this.dropzone.destroy();
        } else {
            this.zone.runOutsideAngular(() => {
                this.dropzone.destroy();
            });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.dropzone && changes['disabled']) {
            if (changes['disabled'].currentValue != changes['disabled'].previousValue) {
                if (changes['disabled'].currentValue === true) {
                    if (this.runInsideAngular) {
                        this.dropzone.enable();
                    } else {
                        this.zone.runOutsideAngular(() => {
                            this.dropzone.enable();
                        });
                    }
                } else if (changes['disabled'].currentValue === false) {
                    if (this.runInsideAngular) {
                        this.dropzone.disable();
                    } else {
                        this.zone.runOutsideAngular(() => {
                            this.dropzone.disable();
                        });
                    }
                }
            }
        }
    }

    reset() {
        if (this.runInsideAngular) {
            this.dropzone.removeAllFiles();
        } else {
            this.zone.runOutsideAngular(() => {
                this.dropzone.removeAllFiles();
            });
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dropzone',
    templateUrl: './dropzone.component.html',
    styleUrls: ['./dropzone.component.css'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: KeyValueDiffers, },
{type: DropzoneConfig, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'disabled': [{ type: Input },],
'config': [{ type: Input },],
'runInsideAngular': [{ type: Input },],
'message': [{ type: Input },],
'placeholder': [{ type: Input },],
'thumbnails': [{ type: Input, args: ['thumbnails', ] },],
'useDropzoneClass': [{ type: HostBinding, args: ['class.dropzone', ] },{ type: Input },],
'useDzWrapperClass': [{ type: HostBinding, args: ['class.dz-wrapper', ] },{ type: Input },],
'dz_drop': [{ type: Output, args: ['drop', ] },],
'dz_dragstart': [{ type: Output, args: ['dragstart', ] },],
'dz_dragend': [{ type: Output, args: ['dragend', ] },],
'dz_dragenter': [{ type: Output, args: ['dragenter', ] },],
'dz_dragover': [{ type: Output, args: ['dragover', ] },],
'dz_dragleave': [{ type: Output, args: ['dragleave', ] },],
'dz_addedfile': [{ type: Output, args: ['addedfile', ] },],
'dz_addedfiles': [{ type: Output, args: ['addedfiles', ] },],
'dz_removedfile': [{ type: Output, args: ['removedfile', ] },],
'dz_thumbnail': [{ type: Output, args: ['thumbnail', ] },],
'dz_error': [{ type: Output, args: ['error', ] },],
'dz_errormultiple': [{ type: Output, args: ['errormultiple', ] },],
'dz_processing': [{ type: Output, args: ['processing', ] },],
'dz_uploadprogress': [{ type: Output, args: ['uploadprogress', ] },],
'dz_sending': [{ type: Output, args: ['sending', ] },],
'dz_success': [{ type: Output, args: ['success', ] },],
'dz_complete': [{ type: Output, args: ['complete', ] },],
'dz_canceled': [{ type: Output, args: ['canceled', ] },],
'dz_maxfilesreached': [{ type: Output, args: ['maxfilesreached', ] },],
'dz_maxfilesexceeded': [{ type: Output, args: ['maxfilesexceeded', ] },],
'dz_processingmultiple': [{ type: Output, args: ['processingmultiple', ] },],
'dz_sendingmultiple': [{ type: Output, args: ['sendingmultiple', ] },],
'dz_successmultiple': [{ type: Output, args: ['successmultiple', ] },],
'dz_completemultiple': [{ type: Output, args: ['completemultiple', ] },],
'dz_canceledmultiple': [{ type: Output, args: ['canceledmultiple', ] },],
'dz_totaluploadprogress': [{ type: Output, args: ['totaluploadprogress', ] },],
'dz_reset': [{ type: Output, args: ['reset', ] },],
'dz_queuecomplete': [{ type: Output, args: ['queuecomplete', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
